export default function OpenHeader() {
    if ($('.c-header__default').length > 0) {

        const $header = {
            container: $('.c-header__default'),
            content: $('.c-header__default--content'),
            background: $('.c-header__default--background')
        }

        TweenMax.fromTo($header.background, 1,
            {
                opacity: 0,
                scale: 1.2,
                ease: Power3.easeInOut,
            },
            {
                opacity: 1,
                scale: 1,
                ease: Power3.easeInOut,
                delay: .6
            }
        );

        TweenMax.fromTo($header.content, 1,
            {
                y: '100%',
                opacity: 0,
                ease: Power3.easeInOut,
            },
            {
                y: '0%',
                opacity: 1,
                ease: Power3.easeInOut,
                delay: .6
            }
        )
    }

}
